export default {
  'app.monitor.trading-activity': 'Real-Time Trading Activity',
  'app.monitor.total-transactions': 'Total transactions today',
  'app.monitor.sales-target': 'Sales target completion rate',
  'app.monitor.remaining-time': 'Remaining time of activity',
  'app.monitor.total-transactions-per-second': 'Total transactions per second',
  'app.monitor.activity-forecast': 'Activity forecast',
  'app.monitor.efficiency': 'Efficiency',
  'app.monitor.ratio': 'Ratio',
  'app.monitor.proportion-per-category': 'Proportion Per Category',
  'app.monitor.fast-food': 'Fast food',
  'app.monitor.western-food': 'Western food',
  'app.monitor.hot-pot': 'Hot pot',
  'app.monitor.waiting-for-implementation': 'Waiting for implementation',
  'app.monitor.popular-searches': 'Popular Searches',
  'app.monitor.resource-surplus': 'Resource Surplus',
  'app.monitor.fund-surplus': 'Fund Surplus',
};
